import type { PushAttentionReason } from '#features/notifications/utils/pushAttention';
import { tracking } from './tracking';

/**
 * Воронка разговора об уведомлениях: «понадобилось спросить → показали → человек ответил».
 *
 * Заведена потому, что спор о шторке разрешать было нечем. Три дня подряд решения принимались
 * по ощущениям: сколько людей её видят, сколько соглашаются, сколько закрывают «Позже» — не знал
 * никто, и единственным фактом было косвенное «139 токенов при ~280 активных устройствах».
 *
 * Считаем и молчаливую ветку тоже: с 13.5 большинство телефонов проходит её вообще без экрана,
 * и без этой отметки успех выглядел бы как отсутствие событий.
 */
const CATEGORY = 'push_permission';

/** Итог тихой попытки забрать токен, когда система уже всё разрешила. */
export type SilentOutcome =
  /** Токен взят молча, человек ничего не увидел. Нормальный, самый частый исход. */
  | 'taken'
  /** Разрешения нет или прочитать не удалось — молча тут ничего не сделать. */
  | 'not-allowed'
  /** Попытка была и не удалась: FCM промолчал, сеть, отказ сервера. Дальше говорит шторка. */
  | 'failed';

/** Шторка показана. label — причина, по которой мы заговорили. */
export const trackPushSheetView = (reason: PushAttentionReason) =>
  tracking.event({ action: 'push_sheet_view', category: CATEGORY, label: reason });

/**
 * Нажата главная кнопка: «Включить» (поднимет системный диалог) или «Открыть настройки».
 * Само согласие ОС здесь не видно — его отражает следующая регистрация токена.
 */
export const trackPushSheetAction = (reason: PushAttentionReason) =>
  tracking.event({ action: 'push_sheet_action', category: CATEGORY, label: reason });

/** «Позже». Ответ, а не ошибка: по нему мы молчим неделю или месяц, смотря о чём спрашивали. */
export const trackPushSheetLater = (reason: PushAttentionReason) =>
  tracking.event({ action: 'push_sheet_later', category: CATEGORY, label: reason });

/** Чем закончилась тихая ветка — та, где человек не видит ничего. */
export const trackPushSilentRegistration = (outcome: SilentOutcome) =>
  tracking.event({ action: 'push_silent_registration', category: CATEGORY, label: outcome });
